import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  cardSidebar: {
    position: 'absolute',
    width: '307px',
    height: 'calc(100% - 140px)',
    backgroundColor: '#FFFFFF',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRight: 'solid 1px rgba(44, 45, 62, 0.3)',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: 30,
    transition: '0.5s ease-in-out',
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  cardSidebarMenu: {
    position: 'absolute',
    left: '7px',
    display: 'flex',
    flexDirection: 'row',
    width: '200px',
    padding: '50px 20px 10px 15px',
    transition: '0.5s ease-in-out',
  },
  cardSidebarMenuItem: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: 'rgba(44, 45, 62, 0.5)',
    padding: '20px 20px 20px 0px',
    cursor: 'pointer',
  },
  cardSidebarMenuItemActive: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: '#2C2D3E',
    padding: '20px 20px 20px 0px',
    cursor: 'pointer',
  },
  cardThumbnails: {
    position: 'absolute',
    left: 'calc(100% - 290px)',
    top: '0px',
    maxHeight: '100%',
    width: '290px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'auto',
    zIndex: 3,
    transition: '0.5s ease-in-out',
  },
  closeIcon: {
    position: 'relative',
    top: '8px',
    left: '125px',
    color: 'rgba(44, 45, 62, 0.8)',
    zIndex: 10,
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
